import React, { ChangeEvent } from "react";

type BasicInputProps = {
  ariaLabel?: string;
  disabled?: boolean;
  errorMsg?: string;
  extraClasses?: string;
  hint?: string;
  inputMode?: "text" | "tel" | "email" | "numeric";
  label: string;
  name: string;
  required?: boolean;
  type?: string;
  value?: string;
  handleInputChange(event: ChangeEvent<HTMLInputElement>): void;
  handleOnBlur?(event: ChangeEvent<HTMLInputElement>): void;
};

export const BasicInput: React.FC<BasicInputProps> = ({
  ariaLabel,
  disabled,
  errorMsg,
  extraClasses,
  handleInputChange,
  handleOnBlur = () => ({}),
  hint,
  inputMode = "text",
  label,
  name,
  required,
  type = "text",
  value = "",
}) => {
  const id = `${name}-${type}-input`;

  return (
    <div className="form_field">
      <div>
        <label className="heading heading_section" htmlFor={id}>
          {label}
        </label>
        <input
          aria-label={ariaLabel}
          className={`input_unlabeled ${extraClasses ? extraClasses : ""}`}
          disabled={disabled}
          id={id}
          inputMode={inputMode}
          name={name}
          onBlur={handleOnBlur}
          onChange={handleInputChange}
          required={required}
          type={type}
          value={value}
        />
        {errorMsg && (
          <span className="form_field_helper form_field_helper_error">
            {errorMsg}
          </span>
        )}
        {hint && <span className="form_field_helper">{hint}</span>}
      </div>
    </div>
  );
};
